import { SpaReview, type SpaReviewDTO } from "../entity/SpaReview"

export default class SpaReviewAPIRepository {
  static getUrl(uuid: string): string {
    const runtime = useRuntimeConfig()
    return `${runtime.public.apiBaseURL}/api/v1/web/spa/${uuid}/reviews`
  }

  static async getReviewsBySpaUUID(uuid: string): Promise<SpaReview[]> {
    const url = SpaReviewAPIRepository.getUrl(uuid)

    const response = await fetch(url)
    if (!response.ok) {
      throw new Error('CURL: ERROR: ' + url)
    }

    const responseJson = await response.json()
    const reviewDtos: SpaReviewDTO[] = responseJson.data

    return reviewDtos.map(SpaReview.from)
  }

  static async publishReview(review: SpaReview): Promise<void> {
    const url = SpaReviewAPIRepository.getUrl(review.spaUUID)

    const respone = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(review.to())
    })

    if (!respone.ok) {
      throw new Error('Cannot publish review')
    }
  }
}
